exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-7379490d]{background:#fff;border:1px solid #ccc;position:absolute;width:400px;height:360px;top:calc(50% - 180px);left:calc(50% - 200px);padding:24px\n}\n.container .title[data-v-7379490d]{font-size:24px;width:100%;line-height:60px;text-align:center\n}\n.container .content[data-v-7379490d]{font-size:14px;width:100%;line-height:40px\n}\n", ""]);

// exports
